import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionsService } from '../permissions.service';

/**
 * Permission-based route guard.
 *
 * Usage in routes:
 * ```ts
 * {
 *   path: 'invoices',
 *   canActivate: [permissionsGuard],
 *   data: { permission: 'invoices:read' }  // single permission
 *   // OR
 *   data: { permissions: ['invoices:read', 'invoices:create'] }  // requires ALL
 * }
 * ```
 */
export const permissionsGuard: CanActivateFn = (route) => {
  const permService = inject(PermissionsService);
  const router = inject(Router);

  const single = route.data?.['permission'] as string | undefined;
  const multi = route.data?.['permissions'] as string[] | undefined;

  // No permission requirement → allow
  if (!single && (!multi || multi.length === 0)) return true;

  // Owner bypasses everything
  if (permService.isOwner()) return true;

  const allowed = single
    ? permService.can(single as string)
    : multi
      ? permService.canAll(...multi)
      : true;

  if (allowed) return true;

  return router.createUrlTree(['/dashboard']);
};
